import lity from 'lity';
$(() => {
  const $gridGalleryImages = $('#gridThumbnails').find('.gallery-img');
  const $defaultImage = $('#gridThumbnails').find('.gallery-img.selected');
  const $imageDetails = $("#imageDetails");
  const heading = $defaultImage.data('location');
  const description = $defaultImage.data('image-description');
  const $selectedThumbnail = $('#selectedImage');

  // By default, assign the heading and description on page load
  $imageDetails.find('.heading').html(heading);
  $imageDetails.find('.description').html(description);

  $('#mainThumbnailImage').parent().on('click', function (e) {
    e.preventDefault();
    const $this = $(this).find('#mainThumbnailImage');
    const thumbnailImage = $this.attr("src") || $this.attr("data-ofi-src");
    const heading = $this.data('location');
    const description = $this.data('image-description');
    $('#mainImage').replaceWith('<img id="mainImage" class="gallery-img" src="' + thumbnailImage + '"  />');

    $imageDetails.find('.heading').html(heading);
    $imageDetails.find('.description').html(description);
    $selectedThumbnail.html($this.data('index') + '/');
    if (!$this.hasClass('selected')) {
      $gridGalleryImages.removeClass('selected');
      $this.addClass('selected');
    }
  });

  // Gallery grid/thumbnail images
  $gridGalleryImages.on('click', function (e) {
    e.preventDefault();
    const $gridImageContainer = $('#gridThumbnails').find('.grid-image');
    const currentImg = $gridImageContainer.find('.gallery-img.selected');
    currentImg.removeClass('selected');
    const $this = $(this);

    const thumbnailImage = $this.attr("src") || $this.attr("data-ofi-src");
    const heading = $this.data('location');
    const description = $this.data('image-description');

    $('#mainImage').replaceWith('<img id="mainImage" class="gallery-img" src="' + thumbnailImage + '"  />');

    $imageDetails.find('.heading').html(heading);
    $imageDetails.find('.description').html(description);
    $selectedThumbnail.html($this.data('index') + '/');
    if (!$this.hasClass('selected')) {
      $gridGalleryImages.removeClass('selected');
      $this.addClass('selected');
    }
  });

  // clicking on previous image
  $("#prevArrow").on('click', clickPrevImage);
  $("#prevArrow").addClass('disable-arrow');

  // clicking on previous image
  $("#nextArrow").on('click', clickNextImage);
  let prevImgCount = 0;
  let nextImgCount = 0;

  function clickNextImage() {
    const $gridImageContainer = $('#gridThumbnails').find('.grid-image');
    const currentImg = $gridImageContainer.find('.gallery-img.selected');
    const $prevImgContainer = currentImg.closest('.grid-image').prev();
    const prevImg = $prevImgContainer.find('.gallery-img');
    const $nextImgContainer = currentImg.closest('.grid-image').next();
    const nextImg = $nextImgContainer.find('.gallery-img');
    const lastIndex = $('#gridThumbnails .grid-image:last-child').find('.gallery-img.selected').data('index');
    prevImgCount++;

    const currentSelected = currentImg.data('index');
    if (currentSelected + 1 <= $('#galleryInnerModal').data('total-images')) {
      $selectedThumbnail.html(currentSelected + 1 + '/');
    }

    if (prevImg.length || prevImgCount >= 1) {
      $("#prevArrow").removeClass('disable-arrow');
    }

    if (nextImg.length) {
      currentImg.removeClass('selected');
      $("#nextArrow").removeClass('disable-arrow');
      const thumbnailImage = nextImg.attr("src") || nextImg.attr("data-ofi-src");
      const heading = nextImg.data('location');
      const description = nextImg.data('image-description');
      $('#mainImage').replaceWith('<img id="mainImage" class="gallery-img" src="' + thumbnailImage + '"  />');

      $imageDetails.find('.heading').html(heading);
      $imageDetails.find('.description').html(description);

      nextImg.addClass('selected');

      if (prevImgCount % 7 === 0) {
        $('#gridThumbnails').animate({
          scrollTop: $('.grid-image').offset().top
        }, 100);
      }

      let currentScroll = $('#gridThumbnails').get(0).scrollLeft;
      let scrollWidth = $('#gridThumbnails').get(0).scrollWidth;
      if ((75 + currentScroll) >= scrollWidth) {
        return;
      } else {
        $('#gridThumbnails').animate({
          scrollLeft: '+=75px'
        }, "slow");
      }
    }

    if ($('#galleryInnerModal').data('total-images') === lastIndex) {
      $("#nextArrow").addClass('disable-arrow');
      $("#prevArrow").removeClass('disable-arrow');
    }
  }


  function clickPrevImage() {
    const $gridImageContainer = $('#gridThumbnails').find('.grid-image');
    const currentImg = $gridImageContainer.find('.gallery-img.selected')
    const $prevImgContainer = currentImg.closest('.grid-image').prev();
    const prevImg = $prevImgContainer.find('.gallery-img');
    const $nextImgContainer = currentImg.closest('.grid-image').next();
    const nextImg = $nextImgContainer.find('.gallery-img');
    const lastIndex = $('#gridThumbnails .grid-image:last-child').find('.gallery-img.selected').data('index');

    nextImgCount++;
    const currentSelected = currentImg.data('index');
    if (currentSelected > 1) {
      $selectedThumbnail.html(currentSelected - 1 + '/');
    }

    if (currentSelected <= 1) {
      $("#prevArrow").addClass('disable-arrow');
      $("#nextArrow").removeClass('disable-arrow');
    }

    if (nextImg.length || $('#galleryInnerModal').data('total-images') === lastIndex) {
      $("#nextArrow").removeClass('disable-arrow');
    }

    if (prevImg.length) {
      currentImg.removeClass('selected');
      $("#prevArrow").removeClass('disable-arrow');
      const thumbnailImage = prevImg.attr("src") || prevImg.attr("data-ofi-src");
      const heading = prevImg.data('location');
      const description = prevImg.data('image-description');

      $('#mainImage').replaceWith('<img id="mainImage" class="gallery-img" src="' + thumbnailImage + '"  />');
      $imageDetails.find('.heading').html(heading);
      $imageDetails.find('.description').html(description);

      prevImg.addClass('selected');

      if (nextImgCount % 7 === 0) {
        $('#gridThumbnails').animate({
          scrollTop: $('.grid-image').offset().top
        }, 100);
      }

      let currentScroll = $('#gridThumbnails').get(0).scrollLeft;
      if ((currentScroll - 75) <= 0) {
        return;
      } else {
        $('#gridThumbnails').animate({
          scrollLeft: '-=75px'
        }, "slow");
      }
    }
  }
  //Scroll to the gallery component
  $("#backArrow").on('click', function () {
    $('html, body').animate({
      scrollTop: $("#galleryContainer").offset().top
    }, 2000);
  });
});
